<template>
  <div class="col-3">
    <label>{{labelText}}</label>

    <k-input
      class="w-100"
      type="text"
      :name="fieldName"
      :value="value"
      @input="$emit('input',$event.target.value)"
      :placeholder="labelText
           "
    ></k-input>
  </div>
</template>
<script>
export default {
  name: "Textbox",
  props: ["placeholder", "labelText", "fieldName", "value"]
};
</script>